import {
  LOGIN_SUCCESS, LOGOUT_SUCCESS
} from '../actions/authActions';

const INITIAL_STATE = {
  uid: '',
  'access-token': '',
  client: '',
  role: 'user',
  name: 'user'
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.user;
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js